export const environment = {
    name: 'development',
    production: false,
    msalConfig: {
        auth: {
            clientId: '36c8c549-30ef-412e-afca-133e6eaad678',
            authority: 'https://login.microsoftonline.com/0ad43537-6a69-43de-83b7-3f6b37c0201d',
            redirectUri: 'https://dev.login.yourexpats.nl',
            postLogoutRedirectUri: 'https://yourexpats.nl/'
        }
    },
    apiConfig: {
        scopes: ['api://36c8c549-30ef-412e-afca-133e6eaad678/access_via_approle_assignments'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    onboardUrl: "https://dev.onboard.yourexpats.nl",
    selectUrl: "https://dev.select.yourexpats.nl",
    findUrl: "https://dev.find.yourexpats.nl",
    testUrl: "https://dev.test.yourexpats.nl"
};
